export default {
  switches: {},
  loaded: false,
};
